
























import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class ActiveLoginBody extends Vue {
  @Prop() readonly data: any;
}
